// Sistema de notificaciones toast simple

// Almacena las notificaciones actuales
let toasts = [];
let nextId = 1;
let listeners = [];

// Tipos de toast disponibles
const TOAST_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
};

// Duración predeterminada de los toasts
const DEFAULT_DURATION = 5000;

// Función para notificar a los componentes de los cambios
const notifyListeners = () => {
  listeners.forEach(listener => listener(toasts));
};

// Añadir una nueva notificación
const addToast = (message, options = {}) => {
  const id = nextId++;
  const toast = {
    id,
    message,
    type: options.type || TOAST_TYPES.INFO,
    duration: options.duration || DEFAULT_DURATION,
    timestamp: Date.now()
  };
  
  toasts = [...toasts, toast];
  notifyListeners();
  
  // Auto-eliminación del toast si tiene duración
  if (toast.duration > 0) {
    setTimeout(() => {
      try {
        removeToast(id);
      } catch (error) {
        // Silenciar errores de eliminación en múltiples instancias
        if (!error.message.includes('Could not establish connection')) {
          console.error('Error removing toast:', error);
        }
      }
    }, toast.duration);
  }
  
  return id;
};

// Eliminar una notificación por ID
const removeToast = (id) => {
  toasts = toasts.filter(toast => toast.id !== id);
  notifyListeners();
};

// Métodos para los distintos tipos de notificaciones
const success = (message, options = {}) => {
  return addToast(message, { type: TOAST_TYPES.SUCCESS, ...options });
};

const error = (message, options = {}) => {
  return addToast(message, { type: TOAST_TYPES.ERROR, ...options });
};

const warning = (message, options = {}) => {
  return addToast(message, { type: TOAST_TYPES.WARNING, ...options });
};

const info = (message, options = {}) => {
  return addToast(message, { type: TOAST_TYPES.INFO, ...options });
};

// Eliminar todas las notificaciones
const clearAll = () => {
  toasts = [];
  notifyListeners();
};

// Suscribirse a cambios
const subscribe = (callback) => {
  listeners.push(callback);
  callback(toasts); // Enviar estado inicial
  
  // Función para cancelar la suscripción
  return () => {
    listeners = listeners.filter(listener => listener !== callback);
  };
};

// Exportar las funciones y constantes
const toastService = {
  addToast,
  removeToast,
  success,
  error,
  warning,
  info,
  clearAll,
  subscribe,
  TOAST_TYPES
};

export default toastService;